import { z } from 'zod';
import {
  dateValidation,
  requiredString,
  coerceBoolean,
} from '../../../validation';

export const CareDocumentWorkDetailsSchema = z
  .object({
    jobTitle: requiredString('Job title is required'),
    dateSignedOff: dateValidation('Date signed off is required'),
    workPattern: requiredString('Work pattern is required'),
    hideHopingToReturnToWorkIn: coerceBoolean(z.boolean()),
    hopingToReturnToWorkIn: z.string().optional(),
  })
  // the answer is only asked for while the question is shown
  .check((ctx) => {
    const { hideHopingToReturnToWorkIn, hopingToReturnToWorkIn } = ctx.value;

    if (hideHopingToReturnToWorkIn !== false || hopingToReturnToWorkIn) {
      return;
    }

    ctx.issues.push({
      code: 'custom',
      input: ctx.value,
      path: ['hopingToReturnToWorkIn'],
      message: 'Hoping to return to work is required',
    });
  });

export type CareDocumentWorkDetails = z.infer<
  typeof CareDocumentWorkDetailsSchema
>;
